import React from "react";
import { Link } from "react-router-dom";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format } from "date-fns";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { surveysListQuestions } from "../../Actions/Surveys/surveyActions.js";

class BiSurveyData extends React.Component {
  constructor(props) {
    super(props);

    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      dateRangePicker: {
        selection: {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      },
      to_date: format(new Date(), "YYYY-MM-DD"),
      from_date: format(new Date(), "YYYY-MM-DD"),
      viewAllsurveysListQuestions: [],
      viewSurveyData: [],
      id: this.props.match.params.id,
      surveyID: this.props.match.params.surveyID,
      globalLang: languageData.global,
      surveyLang: languageData.surveys,
      surveyDetails: [],
    };
  }
  componentDidMount() {
    let questionId = this.state.id;
    const languageData = JSON.parse(localStorage.getItem("languageData"));
    this.setState({
      survey_coolsculpting: languageData.dashboard["survey_coolsculpting"],
      surveys_insights: languageData.surveys["surveys_insights"],
      surveys_survey: languageData.surveys["surveys_survey"],
      survey_que: languageData.dashboard["survey_que"],
      survey_ans: languageData.dashboard["survey_ans"],
      showLoader: true,
    });
    this.props.surveysListQuestions(questionId);
  }

  toggleCalendar = (elem) => {
    if (elem.name !== "calendar-input" && this.state.showCalendar === false) {
      return;
    }

    let showCalendar = false;

    if (
      this.state.showCalendar === false &&
      elem.name !== undefined &&
      elem.name === "calendar-input"
    ) {
      showCalendar = true;
    } else {
      showCalendar = false;
    }
    this.setState({ showCalendar: showCalendar });
  };

  handleRangeChange = (which, payload) => {
    let startDate = payload.selection.startDate;
    let endDate = payload.selection.endDate;
    startDate = format(startDate, "YYYY-MM-DD");
    endDate = format(endDate, "YYYY-MM-DD");

    this.setState({
      [which]: {
        ...this.state[which],
        ...payload,
      },
      showCalendar: false,
      from_date: startDate,
      to_date: endDate,
    });
    this.handleSubmit(which, { from_date: startDate, to_date: endDate });
  };

  handleSubmit = (event, value) => {
    let from_date = "";
    let to_date = "";

    if (typeof event === "object") {
      event.preventDefault();
      //object_name = value
    } else {
      from_date = value.from_date;
      to_date = value.to_date;
    }

    let formData = {
      params: {
        to_date: to_date ? to_date : this.state.to_date,
        from_date: from_date ? from_date : this.state.from_date,
      },
    };

    this.setState({
      page: 1,
      pagesize: this.state.pagesize,
      loadMore: true,
      startFresh: true,
      next_page_url: "",
      showLoader: true,
      objectNames: [],
      userLogList: [],
      dataFiltered: true,
    });
    this.props.surveysListQuestions(formData);
  };

  handleClick = (e) => {
    if (this.node.contains(e.target) && this.state.showCalendar === true) {
      return;
    }
    this.toggleCalendar(e.target);
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.showLoader != undefined && nextProps.showLoader == false) {
      return { showLoader: false };
    }
    if (
      nextProps.viewAllsurveysListQuestions != undefined &&
      nextProps.viewAllsurveysListQuestions.data !=
        prevState.viewAllsurveysListQuestions &&
      nextProps.viewAllsurveysListQuestions.status == 200
    ) {
      localStorage.setItem("loadAgain", false);
      return {
        viewAllsurveysListQuestions: nextProps.viewAllsurveysListQuestions.data,
        viewSurveyData:
          nextProps.viewAllsurveysListQuestions.data.questions_data,
        surveyDetails:
          nextProps.viewAllsurveysListQuestions.data.survey_details,
        showLoader: false,
      };
    }
    return null;
  }

  render() {
    let returnTo = `/business-insight/surveys/view-all`;

    const originalQuestionsMap =
      this.state.surveyDetails?.survey?.survey_questions?.reduce(
        (c, q) => ({ ...c, [q.id]: q }),
        {},
      );

    return (
      <div className="main protected">
        <form onSubmit={this.handleSubmit}>
          <div id="content">
            <div className="container-fluid content setting-wrapper">
              <div className="juvly-section full-width">
                <div className="juvly-container">
                  <div className="juvly-title">
                    {this.state.surveyDetails && this.state.surveyDetails.survey
                      ? this.state.surveyDetails.survey.title
                      : ""}
                    <Link to={returnTo} className="pull-right close_survey">
                      <img alt="" src="/images/close.png" />
                    </Link>
                  </div>
                  {this.state.viewSurveyData !== undefined &&
                    this.state.viewSurveyData.map((qobj, qidx) => {
                      let comment = "";

                      if (qobj.survey_comment) {
                        comment = "(Comment : " + qobj.survey_comment + ")";
                      }

                      const originalQuestion =
                        originalQuestionsMap[qobj.question_id] || {};

                      return (
                        <div key={`ques` + qidx} className="survey-qus-ans">
                          <div className="survey-ques text-black">
                            <span className="que-label">
                              {originalQuestion.required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : (
                                ""
                              )}
                              <b>Ques:</b>
                            </span>
                            {qobj && qobj.question ? qobj.question : ""}
                          </div>

                          {!!originalQuestion.description &&
                            originalQuestion.description_text && (
                              <div className="text-black m-b-8">
                                <span className="que-label">
                                  <b>Description: </b>
                                </span>
                                {originalQuestion.description_text}
                              </div>
                            )}

                          {qobj.question_type === "Multiple Choice" ||
                          qobj.question_type === "Single Choice" ? (
                            qobj.multi_choice_answers &&
                            qobj.multi_choice_answers.length > 0 ? (
                              <div className="survey-ans">
                                <span className="ans-label">
                                  <b>Ans:</b>
                                </span>
                                {qobj.multi_choice_answers.join(", ")}
                              </div>
                            ) : (
                              <span className="survy-ans">____</span>
                            )
                          ) : qobj.question_type === "Opinion Scale" ||
                            qobj.question_type === "scale" ? (
                            qobj.score ? (
                              <div className="survey-ans">
                                <span className="ans-label">
                                  <b>Ans:</b>
                                </span>
                                {qobj.score} <br /> {comment}
                              </div>
                            ) : (
                              <div className="survey-ans">
                                <span className="ans-label">
                                  <b>Ans:</b>
                                </span>
                                ____
                                <br /> {comment}
                              </div>
                            )
                          ) : qobj.question_type === "File Upload" &&
                            qobj.answer ? (
                            <div className="survey-ans">
                              <span className="ans-label">
                                <b>Ans:</b>
                              </span>
                              <img
                                alt="Uploaded File"
                                src={qobj.answer}
                                width="200px"
                              />
                            </div>
                          ) : qobj.answer ? (
                            <div className="survey-ans">
                              <span className="ans-label">
                                <b>Ans:</b>
                              </span>
                              {qobj.answer}
                            </div>
                          ) : (
                            <span className="survy-ans">____</span>
                          )}
                        </div>
                      );
                    })}
                </div>
                <div
                  className={
                    this.state.showLoader
                      ? "new-loader text-left displayBlock"
                      : "new-loader text-left"
                  }
                >
                  <div className="loader-outer">
                    <img
                      alt=""
                      id="loader-outer"
                      src="/images/Eclipse.gif"
                      className="loader-img"
                    />
                    <div id="modal-confirm-text" className="popup-subtitle">
                      {this.state.surveyLang.survey_processing_please_wait}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const returnState = {};
  if (state.surveyReducer.action === "SURVEYS_LIST_QUESTIONS") {
    if (state.surveyReducer.data.status != 200) {
      returnState.showLoader = false;
    } else {
      returnState.viewAllsurveysListQuestions = state.surveyReducer.data;
    }
  }
  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      surveysListQuestions: surveysListQuestions,
    },
    dispatch,
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(BiSurveyData);
